
















import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import { pageData } from "@/store/pageData";
import { FETCH_PAGE_BY_ID } from "../store/actions.names";

import axios from "axios";

@Component({
  name: "Error404page",
})
export default class Error404page extends Vue {}
